export default "__VITE_ASSET__XRZM3DP9__"